var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card",class:{ 'card--left': _vm.isLeft, 'card--blue': _vm.isBlue }},[_c('div',{staticClass:"card--header"},[(_vm.icon)?_c('div',{staticClass:"illustrated"},[_c('i',{class:_vm.icon})]):_vm._e(),_c('div',{staticClass:"headline"},[_vm._t("header")],2)]),_c('div',{staticClass:"card--body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }